import { MemberStatusEnum } from '@/api/enum/common.enum';
import { Box, Chip } from '@mui/material';

interface Props {
	status: number | string | undefined;
	label: string;
}

const admittedStatuses: number[] = [
	MemberStatusEnum.InProgressAdmitted,
	MemberStatusEnum.AwaitingAssignmentAdmitted,
	MemberStatusEnum.PendingIntakeAdmitted,
	MemberStatusEnum.IntakeCompletedAdmitted,
];

const noAdmittedStatuses: number[] = [
	MemberStatusEnum.InProgressNoAdmitted,
	MemberStatusEnum.AwaitingAssignmentNoAdmitted,
	MemberStatusEnum.PendingIntakeNoAdmitted,
	MemberStatusEnum.IntakeCompletedNoAdmitted,
];

export default function MemberStatusChip({ status, label }: Props) {
	return (
		<Chip
			color={
				admittedStatuses.includes(Number(status))
					? 'chipTertiary'
					: noAdmittedStatuses.includes(Number(status))
					? 'chipPrimary'
					: 'default'
			}
			sx={{
				height: 'auto',
				minHeight: '24px',
				maxWidth: '100%',
				overflow: 'hidden',
				whiteSpace: 'normal',
				wordBreak: 'break-word',
				padding: '4px 4px',
			}}
			label={
				<Box
					sx={{
						width: '100%',
						whiteSpace: 'normal',
						wordBreak: 'break-word',
					}}
				>
					{label}
				</Box>
			}
		/>
	);
}
